module.exports = __webpack_public_path__ + "img/loading.c487eab7.gif";